import React from 'react';

import { SVGPropsType } from 'src/types';

function Transfer(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M11.375 8.49643L9.20831 10.6631"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.625 8.49643H11.375"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.625 5.24643L3.79167 3.07976"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.375 5.24643H1.625"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Transfer;
